<template>
  <b-card
    no-body
  >
    <b-card-body>
      <b-card-title>Приложения</b-card-title>
      <b-card-sub-title>Материалы, возникшие при замере </b-card-sub-title>
    </b-card-body>
    <b-table
      striped
      responsive
      :fields="tableColumns"
      :items="attachmentsData"
      class="mb-0"
      show-empty
      empty-text="Записей не найдено"
    >
      <template #cell(attachment)="data">
        <b-media vertical-align="center">
          <b-link
              :href="data.item.attachment.upload_file "
              target="_blank"
              class="font-weight-bold text-nowrap media-body mb-0"
              v-b-tooltip.hover.top="data.item.attachment.name"
            >

              <b-img :src="require('@/assets/images/icons/doc.png')" height="23"/>
            </b-link>
        </b-media>
      </template>
    </b-table>
  </b-card>
</template>

<script>

import {
  BCard, BTable, BCardBody, BCardTitle, BCardSubTitle, BFormCheckbox, BMedia, BLink, BImg, VBTooltip
} from 'bootstrap-vue'

import { title } from '@core/utils/filter'

export default {
  components: {
    BCard, BTable, BCardBody, BCardTitle, BCardSubTitle, BFormCheckbox, BMedia, BLink, BImg, VBTooltip,
  },
  props: {
    attachmentsData: {
      type: Array,
      required: true,
    },

  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  setup() {


    const tableColumns = [

      { key: 'attachment.name',
        label: 'название',
        formatter: title,
        sortable: true
      },

      { key: 'attachment.type.type',
        label: 'тип',
        formatter: title,
        sortable: true
      },
      { key: 'attachment',
        label: 'приложение',
        formatter: title,
        sortable: true
      }
    ];


    return {
      tableColumns,
    }
  },
}
</script>

<style>

</style>
